import { X } from 'lucide-react'
import successCheck from '../assets/images/phase2_live/success-check.png'
import { CommonButton } from './CommonButton'

interface TransactionSuccessModalProps {
  isOpen: boolean
  onClose: () => void
}

export function TransactionSuccessModal({ isOpen, onClose }: TransactionSuccessModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-[#100131] bg-opacity-60"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative w-full max-w-full bg-[#F8FAFC] rounded-t-[40px] px-[31px] pt-[60px] pb-[120px]">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-6 h-6 flex items-center justify-center text-[#676C77]"
        >
          <X className="w-[24px] h-[24px] stroke-2" />
        </button>

        <div className="flex flex-col items-center gap-2.5">
          {/* Success Icon */}
          <div className="w-[62px] h-[62px] mb-2.5">
            <img 
              src={successCheck} 
              alt="Success" 
              className="w-full h-full object-contain"
            />
          </div>

          {/* Title */}
          <h2 className="font-kanit font-bold text-[#280D5E] text-2xl leading-[17px] text-center mb-2.5">
            Subscription Confirmed
          </h2>

          {/* Description */}
          <p className="font-kanit font-medium text-[#280D5E] text-lg leading-[25px] text-center mb-6">
            Download the PIN AI app to activate your Personal AI and start earning token rewards.
            <br />
            The sooner you start, the more PIN you can earn during the campaign.
          </p>

          {/* Action Button */}
          <div className="w-full max-w-[300px]">
            <CommonButton 
              text="Start Earning" 
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </div>
  )
} 